import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-14 md:py-20 px-4 md:px-6 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20style%20background%2C%20warm%20coral%20and%20golden%20abstract%20illustration%2C%20flowing%20soft%20gradient%20shapes%2C%20artistic%20and%20elegant%2C%20dreamy%20atmosphere%2C%20subtle%20texture%2C%20suitable%20for%20web%20CTA%20section%20background&width=1600&height=600&seq=cta-bg-2026&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/40" />
      <div className="relative max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-xl md:text-3xl font-bold text-white mb-3 md:mb-4">
          开启你的韩漫之旅
        </h2>
        <p className="text-sm md:text-base text-white/80 mb-6 md:mb-8 leading-relaxed">
          从热门推荐到冷门佳作，韩漫漫画网帮你发现每一部值得阅读的韩国漫画。
        </p>
        <Link
          to="/category/all"
          className="inline-flex px-8 py-3.5 bg-accent-500 text-background-50 font-semibold rounded-lg hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap text-sm"
        >
          立即浏览漫画大全
        </Link>
      </div>
    </section>
  );
}